import { cn } from '@heidi/utils';

/** Shared base styles for interactive context menu items (Item, SubTrigger, CheckboxItem, RadioItem) */
export const contextMenuItemBaseStyles = cn(
  'flex cursor-default select-none items-center gap-2 rounded-md text-sm outline-none hover:bg-surface-hover hover:text-text-primary focus:bg-surface-hover focus:text-text-primary active:bg-surface-pressed [&>svg]:size-4 [&>svg]:shrink-0'
);

export const contextMenuSubTriggerClasses = cn(
  'px-2 py-1.5 data-[state=open]:bg-surface-hover data-[state=open]:text-text-primary'
);

export const contextMenuSubContentClasses = cn(
  'z-50 min-w-32 origin-[var(--radix-context-menu-content-transform-origin)] overflow-hidden rounded-lg border-0 bg-surface-elevated p-1 text-text-primary shadow-popover-elevated ring-1 ring-surface-elevated-border data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2'
);

export const contextMenuContentClasses = cn(
  'z-50 min-w-32 origin-[var(--radix-context-menu-content-transform-origin)] overflow-hidden rounded-lg border-0 bg-surface-elevated p-1 text-text-primary shadow-popover ring-1 ring-surface-elevated-border animate-in fade-in-80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2'
);

export const contextMenuItemClasses = cn(
  'relative cursor-pointer px-2 py-1.5 data-[disabled]:pointer-events-none data-[disabled]:opacity-50'
);

export const contextMenuItemDestructiveClasses = cn(
  'text-validation-destructive hover:bg-validation-destructive-muted hover:text-validation-destructive-hover focus:bg-validation-destructive-muted focus:text-validation-destructive active:bg-validation-destructive-muted active:text-validation-destructive-pressed'
);

export const contextMenuCheckboxItemClasses = cn(
  'relative py-1.5 pe-2 ps-8 data-[disabled]:pointer-events-none data-[disabled]:opacity-50'
);

export const contextMenuRadioItemClasses = cn(
  'relative py-1.5 pe-2 ps-8 data-[disabled]:pointer-events-none data-[disabled]:opacity-50'
);

export const contextMenuLabelClasses = cn(
  'px-2 py-1.5 text-sm font-semibold text-text-primary'
);

export const contextMenuSeparatorClasses = cn('-mx-1 my-1 h-px bg-border');

export const contextMenuShortcutClasses = cn(
  'ms-auto text-xs tracking-widest text-text-secondary'
);
